import { Endpoint } from "../config";

export type ReportEndpointType =
  | "reports"
  | "viewReport"
  | "createReport"
  | "updateReport";

export const reportEndpoints: Record<ReportEndpointType, Endpoint> = {
  reports: {
    url: "reports/",
  },
  viewReport: {
    url: "reports",
  },
  createReport: {
    url: "reports/",
  },
  updateReport: {
    url: "reports/",
  },
};
